import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useRef, useState, useEffect, useContext } from 'react';
import { useRouter } from 'next/router';

import { StateContext } from '@/context/index';

import Text from '@/atoms/Text/Text';
import Icon from '@/atoms/Icon/Icon';

function ButtonDropdown() {
  const dropdownNode = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();

  //add event listener to close dropdown when clicking outside of dropdown's node
  useEffect(() => {
    const handleHideDropdown = (e) => {
      //if clicked outside of dropdown then close dropdown
      if (!dropdownNode?.current?.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleHideDropdown);

    return () => document.removeEventListener('click', handleHideDropdown);
  }, []);

  const switchLocale = () => {
    router.push(
      { pathname: router.pathname, query: router.query },
      router.asPath,
      { locale: router.locale === 'en-US' ? 'en-AU' : 'en-US' }
    );
  };

  //todo: make this less of a janky hack
  let firstOption = 'Australian Cuts';
  let secondOption = 'American Cuts';
  if (router.locale === 'en-US') {
    firstOption = 'American Cuts';
    secondOption = 'Australian Cuts';
  }
  return (
    <div className="button-dropdown relative z-20 w-[158px] text-center py-1 md:py-0">
      <div
        className={`flex flex-row justify-evenly my-0 mx-auto p-2  rounded-full transition-[opacity] duration-1000 ease-in-out ${
          isOpen ? 'bg-acacia opacity-0' : 'bg-white opacity-1'
        }`}
        role="button"
        onClick={() => setIsOpen(true)}
        ref={dropdownNode}
      >
        <div className="flex items-center">
          <Text tag="button" style={isOpen ? 'text-acacia' : 'text-majesty-5'}>
            {firstOption}
          </Text>
        </div>
        <div className="flex items-center">
          <Icon
            name="arrow"
            width={10}
            height={10}
            className={`transition-transform duration-1000 text-dark-warm-grey ${
              isOpen && 'rotate-180'
            }`}
          />
        </div>
      </div>
      <div
        className={`absolute top-0 left-0  flex flex-col px-[15px] md:shadow-xl bg-white w-[158px]
         ${isOpen ? 'h-[75px]' : 'h-0'} transition-all ease-in-out duration-400 overflow-hidden mt-1 cursor-pointer rounded-xl`}
      >
        <Text tag="button" style="text-eucalyptus pt-2.5">
          {firstOption}
        </Text>
        <div onClick={switchLocale} role="button" className="py-2.5">
          <Text tag="button" style="text-black">
            {secondOption}
          </Text>
        </div>
      </div>
    </div>
  );
}

ButtonDropdown.propTypes = {};

ButtonDropdown.defaultProps = {};

export default ButtonDropdown;
